module.exports = __webpack_public_path__ + "static/media/tick.94b19153.svg";